export interface TriggersHitListState {
    shouldRefresh: object;
}

export function getDefaultTriggersHitListState(): TriggersHitListState {
    return {
        shouldRefresh: {},
    };
}
